import { Check, Lock, X } from "lucide-react";

// Renders the nine-gate checklist. Gates disabled for the tenant (via feature
// flags) are shown muted — proving the gate set is config-driven.
export default function GateChecklist({ gates }) {
  return (
    <div data-testid="gate-checklist" className="space-y-1.5">
      {gates.map((g) => {
        const state = !g.enabled ? "disabled" : g.satisfied ? "ok" : "missing";
        return (
          <div key={g.key} data-testid={`gate-${g.key}`}
            className={`flex items-center justify-between rounded-lg border px-3 py-2 text-sm ${
              state === "ok" ? "border-status-available/30 bg-status-available/10"
              : state === "missing" ? "border-status-recovery/30 bg-status-recovery/10"
              : "border-border bg-muted/40 opacity-60"
            }`}>
            <span className="flex items-center gap-2">
              {state === "ok" && <Check className="h-4 w-4 text-status-available" />}
              {state === "missing" && <X className="h-4 w-4 text-status-recovery" />}
              {state === "disabled" && <Lock className="h-3.5 w-3.5 text-muted-foreground" />}
              {g.label}
            </span>
            <span className="text-xs text-muted-foreground">
              {state === "disabled" ? "not required" : state === "ok" ? "met" : "missing"}
            </span>
          </div>
        );
      })}
    </div>
  );
}
